import {
  FILEUPLOAD,
  GET_USER_PERMISSION,
  GET_CUSTOMER_LIST,
  GET_PROJECT_LIST,
  GET_VENDOR_LIST,
  LIST_OF_PRODUCT_DROPDOWN,
  LISTOFBANK,
  LISTOFCITY,
  LISTOFCOUNTRY,
  LISTOFSTATE,
  MANUFACTURERLIST,
  MATERIALGROUP,
  MATERIALLIST,
  GET_STORE_LIST,
  WORK_ORDER_DATA,
  DELETE_FILE,
  IMPORT_PRODUCT_DATA,
  LIST_OF_UOM,
} from "./ApiRoutes";
import {
  authData,
  multipartData,
  multipartDataWithToken,
  nonAuthData,
} from "./services";

export const listOfCountry = async (data: object) => {
  const response = await nonAuthData.post(LISTOFCOUNTRY, data);
  return response?.data;
};
export const listOfState = async (data: object) => {
  const response = await nonAuthData.post(LISTOFSTATE, data);
  return response?.data;
};
export const listOfCity = async (data: object) => {
  const response = await nonAuthData.post(LISTOFCITY, data);
  return response?.data;
};
export const listOfBank = async (data: object) => {
  const response = await nonAuthData.post(LISTOFBANK, data);
  return response?.data;
};
export const fileUpload = async (data: object) => {
  const response = await multipartData.post(FILEUPLOAD, data);
  return response?.data;
};
export const fileDeleteApi = async (data: any) => {
  const response = await authData.delete(DELETE_FILE, { data: data });
  return response?.data;
};
export const materialListApi = async (data: object) => {
  const response = await multipartData.post(MATERIALLIST, data);
  return response?.data;
};
export const materialGroupListApi = async (data: object) => {
  const response = await multipartData.post(MATERIALGROUP, data);
  return response?.data;
};
export const manufacturerListApi = async (data: object) => {
  const response = await multipartData.post(MANUFACTURERLIST, data);
  return response?.data;
};
export const listOfProductForDropdown = async () => {
  const response = await nonAuthData.get(LIST_OF_PRODUCT_DROPDOWN);
  return response?.data;
};
export const listOfVendorForDropdown = async () => {
  const response = await nonAuthData.get(GET_VENDOR_LIST);
  return response?.data;
};
export const listOfUomForDropdown = async () => {
  const response = await nonAuthData.get(LIST_OF_UOM);
  return response?.data;
};
export const getUserPermission = async (id: number) => {
  const response = await authData.get(`${GET_USER_PERMISSION}${id}`);
  return response?.data;
};
export const getProjectList = async (data: object) => {
  const response = await nonAuthData.post(GET_PROJECT_LIST, data);
  return response?.data;
};
export const getCustomerList = async (data: object) => {
  const response = await nonAuthData.get(GET_CUSTOMER_LIST, data);
  return response?.data;
};
export const getStoreList = async (data: object) => {
  const response = await nonAuthData.post(GET_STORE_LIST, data);
  return response?.data;
};

export const workOrderDataApi = async (id: number) => {
  const response = await authData.get(`${WORK_ORDER_DATA}/${id}`);
  return response?.data;
};

export const ProductfileUpload = async (data: object) => {
  const response = await multipartDataWithToken.post(IMPORT_PRODUCT_DATA, data);
  return response?.data;
};
